import React from 'react'
import { Link } from "react-router-dom";


const HomeAbout = () => {
    return (
        <>

            <div className="about-us" style={{marginTop:"-50px"}}>
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-xl-6">
                            {/* About Us Image Box Start */}
                            <div className="about-us-image-box wow fadeInUp" style={{ visibility: 'visible', animationName: 'fadeInUp' }}>
                                {/* About Us Image Box 1 Start */}
                                <div className="about-us-image-box-1">
                                    {/* About Us Image Start */}
                                    <div className="about-us-image">
                                        <figure className="image-anime">
                                            <img src="./assets/solar/about-us-image-1.webp" alt />
                                        </figure>
                                    </div>
                                    {/* About Us Image End */}
                                    {/* About Us Counter Box Start */}
                                    <div className="about-us-counter-box">
                                        <h2><span className="counter">10</span>+</h2>
                                        <p>Years Of Experience</p>
                                    </div>
                                    {/* About Us Counter Box End */}
                                </div>
                                {/* About Us Image Box 1 End */}
                                {/* About Us Image Box 2 Start */}
                                <div className="about-us-image-box-2">
                                    {/* Contact Us Circle Start */}
                                    <div className="contact-us-circle">
                                        <a to="contact.html">
                                            {/* <img src="./assets/solar/about_1.webp" alt style={{height:"130px",width:"130px"}} /> */}
                                        </a>
                                    </div>
                                    {/* Contact Us Circle End */}
                                    {/* About Us Image Start */}
                                    <div className="about-us-image">
                                        <figure className="image-anime">
                                            <img src="./assets/solar/about-us-image-2.webp" alt />
                                        </figure>
                                    </div>
                                    {/* About Us Image End */}
                                </div>
                                {/* About Us Image Box 2 End */}
                            </div>
                            {/* About Us Image Box End */}
                        </div>
                        <div className="col-xl-6">
                            {/* About Us Content Start */}
                            <div className="about-us-content">
                                {/* Section Title Start */}
                                <div className="section-title">
                                    <span className="section-sub-title wow fadeInUp" style={{ visibility: 'visible', animationName: 'fadeInUp' }}>About Us </span>
                                    <h2 className="text-anime-style-3" data-cursor="-opaque" aria-label="Building a green tomorrow through clean energy" style={{ perspective: 400 }}>
                                        <div className="split-line" aria-hidden="true" style={{ position: 'relative', display: 'block', textAlign: 'start' }}>
                                            <div aria-hidden="true" style={{ position: 'relative', display: 'inline-block' }}>
                                                Powering a Brighter Future with Clean Solar Energy
                                            </div>
                                        </div>
                                    </h2>
                                    <p className="wow fadeInUp" data-wow-delay="0.2s" style={{ visibility: 'visible', animationDelay: '0.2s', animationName: 'fadeInUp', textAlign:"justify" }}>Solar World Enterprises is a trusted solar energy solutions company committed to helping homes, businesses, industries, and institutions transition towards clean, reliable, and cost-effective renewable energy. We believe that solar power is not just an alternative source of energy—it is a smarter investment for a sustainable future.</p>
                                    <p className="wow fadeInUp" data-wow-delay="0.2s" style={{ visibility: 'visible', animationDelay: '0.2s', animationName: 'fadeInUp', textAlign:"justify" }}>With a focus on quality, innovation, and customer satisfaction, we provide comprehensive solar solutions designed to meet the unique energy requirements of our customers. From consultation and system design to installation, maintenance, and after-sales support, our team works closely with clients at every stage of their solar journey.</p>
                                </div>
                                {/* Section Title End */}
                                {/* About Us Body Start */}
                                <div className="about-us-body">
                                    {/* About Us Item List Start */}
                                    <div className="about-us-item-list wow fadeInUp" data-wow-delay="0.4s" style={{ visibility: 'visible', animationDelay: '0.4s', animationName: 'fadeInUp' }}>
                                        {/* About Us Item Start */}
                                        <div className="about-us-item">
                                            <div className="icon-box">
                                                <img src="./assets/images/icon-about-us-item-1.svg" alt />
                                            </div>
                                            <div className="about-us-item-content">
                                                <h3>Our Mission</h3>
                                                <p style={{textAlign:"justify"}}>Our mission is to make clean and renewable energy accessible, affordable, and dependable for everyone. We aim to deliver high-quality solar solutions that reduce electricity costs, minimize environmental impact, and provide long-term value to our customers.</p>
                                            </div>
                                        </div>
                                        {/* About Us Item End */}
                                        {/* About Us Item Start */}
                                        <div className="about-us-item">
                                            <div className="icon-box">
                                                <img src="./assets/images/icon-about-us-item-2.svg" alt />
                                            </div>
                                            <div className="about-us-item-content">
                                                <h3>Our Vision</h3>
                                                <p style={{textAlign:"justify"}}>Our vision is to contribute to a greener and more sustainable world by becoming a leading provider of innovative solar energy solutions. We aspire to create a future where clean energy powers homes, businesses, and communities while reducing dependence on conventional energy sources.</p>
                                            </div>
                                        </div>
                                        {/* About Us Item End */}
                                    </div>
                                    {/* About Us Item List End */}
                                    {/* About Us Body Image Start */}
                                    <div className="about-us-body-image">
                                        <figure className="image-anime reveal" style={{ opacity: 1, visibility: 'inherit', translate: 'none', rotate: 'none', scale: 'none', transform: 'translate(0px, 0px)' }}>
                                            {/* <img src="./assets/images/about-us-body-image.jpg" alt style={{ translate: 'none', rotate: 'none', scale: 'none', transform: 'translate(0px, 0px)' }} /> */}
                                        </figure>
                                    </div>
                                    {/* About Us Body Image Start */}
                                </div>
                                {/* About Us Body End */}
                                {/* About Us Footer Start */}
                                <div className="about-us-footer wow fadeInUp" data-wow-delay="0.6s" style={{ visibility: 'visible', animationDelay: '0.6s', animationName: 'fadeInUp', marginTop:"-20px" }}>
                                    {/* About Us Button Start */}
                                    <div className="about-us-btn">
                                        <Link to="/about" className="btn-default">Learn More</Link>
                                    </div>
                                    {/* About Us Button End */}
                                    {/* Video Play Button Start */}
                                    <div className="video-play-button" data-cursor-text="Play">
                                        <a to="https://www.youtube.com/watch?v=Y-x0efG1seA" className="popup-video">
                                            <span><i className="fa-solid fa-play" /></span>
                                            <p>Watch Our Story</p>
                                        </a>
                                    </div>
                                    {/* Video Play Button End */}
                                </div>
                                {/* About Us Footer End */}
                            </div>
                            {/* About Us Content End */}
                        </div>
                    </div>
                </div>
            </div>


        </>
    )
}

export default HomeAbout